import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import StoreHeader from '../../components/StoreHeader';
import CoverageArt from '../auth/CoverageArt';
import './notfound.css';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="notfound">
      <StoreHeader />
      <main className="notfound-main">
        <CoverageArt />
        <div className="notfound-inner">
          <p className="notfound-eyebrow">
            <span className="notfound-dot" />
            {t('notfound.eyebrow')}
          </p>
          <div className="notfound-code">404</div>
          <h1 className="notfound-title">{t('notfound.title')}</h1>
          <p className="notfound-message">{t('notfound.message')}</p>
          <Link to="/" className="notfound-cta">
            {t('home.detail.back')}
            <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
